/**
 * Barra de promos del carrito (3x2 en 100 ml · 4x3 en 30 ml).
 *
 * Cuenta las unidades de cada tamaño leyendo la opción de variante (p. ej.
 * "Tamaño: 100ml") y pinta, en cada [data-cm-cartbar], la promo del tamaño que
 * hay en el carrito con el mismo estilo que la barra de progreso de Kaching.
 * El contenedor se pone en el bloque "HTML personalizado" de Kaching Cart;
 * si no existe, se inserta al inicio del contenido del drawer de Kaching.
 *
 * Kaching muta el carrito con sus propios fetch/XHR sin publicar el pub/sub
 * del tema, y vuelve a pintar su HTML: por eso se interceptan las llamadas a
 * /cart/* y un MutationObserver vuelve a llenar el contenedor si se vacía.
 */
(function () {
  if (window.cmCartPromos) return;

  var configEl = document.getElementById('cm-cart-promos-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('[cm-cart-promos] Configuración inválida', e);
    return;
  }

  var MOUNT = '[data-cm-cartbar]';
  var AUTO_TARGET = '.kaching-cart__contents';
  var counts = config.initial || {};
  var html = '';

  function norm(str) {
    return String(str || '').toLowerCase().replace(/\s+/g, '');
  }

  function sizeOf(item) {
    var name = norm(config.option);
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (norm(opts[i].name) === name) return norm(opts[i].value);
    }
    return norm(item.variant_title);
  }

  function countSizes(cart) {
    var result = {};
    config.promos.forEach(function (p) {
      result[p.id] = 0;
    });
    (cart.items || []).forEach(function (item) {
      var size = sizeOf(item);
      config.promos.forEach(function (p) {
        if (size === norm(p.size)) result[p.id] += item.quantity;
      });
    });
    return result;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // **texto** -> <strong>texto</strong>; {n} y {free} se reemplazan
  function fill(text, vars) {
    return escapeHtml(text)
      .replace(/\{n\}/g, vars.n)
      .replace(/\{free\}/g, vars.free)
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  }

  var PERCENT_ICON =
    '<svg class="cm-cartbar__icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
    '<circle cx="10" cy="10" r="8.25" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
    '<path d="M6.5 13.5l7-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '<circle cx="7.2" cy="7.2" r="1.3" fill="currentColor"/><circle cx="12.8" cy="12.8" r="1.3" fill="currentColor"/></svg>';

  function stepLabel(p, k, group) {
    if (k === group) return p.freeLabel;
    return (k === 1 ? p.stepOne : p.stepMany).replace(/\{k\}/g, k);
  }

  function rowHtml(p, qty, force) {
    var group = p.buy + 1;
    var step = qty % group;
    var free = Math.floor(qty / group);
    var unlocked = qty > 0 && step === 0;
    var missing = p.buy - step;
    var text;

    if (qty === 0) {
      if (!force) return '';
      text = p.textEmpty;
    } else if (unlocked) {
      text = p.textUnlocked;
    } else if (missing === 0) {
      text = p.textLast;
    } else {
      text = p.textProgress;
    }
    if (qty > 0 && !unlocked && free > 0 && config.earnedPrefix) {
      text = config.earnedPrefix + ' ' + text;
    }

    var filled = unlocked ? group : step;
    var nodes = '';
    var labels = '';
    for (var k = 1; k <= group; k++) {
      var on = k <= filled;
      var pos = (k / group) * 100;
      var edge = k === group ? ' is-last' : '';
      var mark = on ? '✅ ' : (k === group ? '🔒 ' : '');
      nodes += '<span class="cm-cartbar__node' + (on ? ' is-on' : '') + edge + '" style="left:' + pos + '%"></span>';
      labels +=
        '<span class="cm-cartbar__step' + (on ? ' is-on' : '') + edge + '" style="left:' + pos + '%">' +
          PERCENT_ICON +
          '<span class="cm-cartbar__step-text">' + mark + escapeHtml(stepLabel(p, k, group)) + '</span>' +
        '</span>';
    }

    return (
      '<div class="cm-cartbar__row' + (unlocked ? ' is-unlocked' : '') + '">' +
        '<p class="cm-cartbar__text">' + fill(text, { n: missing, free: free }) + '</p>' +
        '<div class="cm-cartbar__track" aria-hidden="true">' +
          '<span class="cm-cartbar__fill" style="width:' + (filled / group) * 100 + '%"></span>' +
          nodes +
        '</div>' +
        '<div class="cm-cartbar__steps" aria-hidden="true">' + labels + '</div>' +
      '</div>'
    );
  }

  // Solo sale la promo del tamaño que hay en el carrito. Si no hay ninguno de
  // los dos tamaños, se pueden mostrar las invitaciones (opción "showEmpty").
  function build() {
    var none = config.promos.every(function (p) {
      return !(counts[p.id] > 0);
    });
    var rows = config.promos.map(function (p) {
      return rowHtml(p, counts[p.id] || 0, none && config.showEmpty);
    }).join('');
    html = rows ? '<div class="cm-cartbar" data-cm-cartbar-filled>' + rows + '</div>' : '';
  }

  function paint(mount) {
    if (mount.__cmHtml === html && (html === '' || mount.querySelector('[data-cm-cartbar-filled]'))) return;
    mount.innerHTML = html;
    mount.__cmHtml = html;
    mount.setAttribute('aria-live', 'polite');
  }

  function ensureMounts() {
    if (config.autoInsert && !document.querySelector(MOUNT)) {
      var target = document.querySelector(AUTO_TARGET);
      if (target) {
        var div = document.createElement('div');
        div.setAttribute('data-cm-cartbar', '');
        div.setAttribute('data-cm-cartbar-auto', '');
        target.insertBefore(div, target.firstChild);
      }
    }
    document.querySelectorAll(MOUNT).forEach(paint);
  }

  function refresh() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        counts = countSizes(cart);
        build();
        ensureMounts();
      })
      .catch(function (error) {
        console.error('[cm-cart-promos] No se pudo leer el carrito', error);
      });
  }

  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 250);
  }

  function hookCartMutations() {
    var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = originalFetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) {
        result.then(scheduleRefresh).catch(function () {});
      }
      return result;
    };

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (url && CART_MUTATION.test(String(url))) {
        this.addEventListener('load', scheduleRefresh);
      }
      return originalOpen.apply(this, arguments);
    };
  }

  // Kaching vuelve a pintar el drawer: si el contenedor aparece vacío, se llena
  var observeTimer = null;
  function observe() {
    new MutationObserver(function () {
      clearTimeout(observeTimer);
      observeTimer = setTimeout(ensureMounts, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    build();
    ensureMounts();
    refresh();
    observe();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    }
  }

  window.cmCartPromos = { refresh: refresh };
  hookCartMutations();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
